export default {
  common: {
    error: 'Something went wrong.',
    accessDenied: 'You are not allowed to access this page',
    saveSuccess: 'Save successful',
  },
  validation: {
    common: "Sorry, your changes couldn't be saved. Please fix errors and try again.",
    default: 'Invalid field value',
    password:
      'Password should have min 8 characters, at least one uppercase letter, one lowercase letter and one number',
    confirmPassword: 'Field value should match new password',
    blankField: 'Field could not be blank',
    lengthError: (min = 1, max = 255) => `Field should contain from ${min} to ${max} characters`,
    emailInvalid: 'Invalid email format',
    emailNotUnique: 'Email is taken. Try another one',
    customerNumberNotUnique: 'Customer number is taken. Try another one',
    requiredForReport: 'Field required to generate Report',
    phone: 'Invalid phone number format',
  },
  request: {
    profileError: "Couldn't retrieve profile info. Please reload this page or try again later.",
    usersListError: "Couldn't retrieve users list. Please try again later.",
    testsListError: "Couldn't retrieve tests list. Please try again later.",
    companiesListError: "Couldn't retrieve companies list. Please try again later.",
    userActivationError: "Sorry, the user couldn't be activated. Email is taken. ",
  },
};



// WEBPACK FOOTER //
// src/constants/messages.js